export default class HeroHome {


	// Constructor
	constructor(asscroll, element) {
		this.asscroll = asscroll;
		this.element = element;
		this.scroll = this.scroll.bind(this);
		this.heading = this.element.querySelector('h2');
	}


	// Public Methods
	destroy() {
		this.disable();
		delete this.asscroll;
		delete this.element;
		delete this.heading;
	}
	enable() {
		this.asscroll.on('update', this.scroll);
	}
	disable() {
		this.asscroll.off('update', this.scroll);
	}


	// Event Handlers
	scroll() {
		const { top } = this.element.getBoundingClientRect();
		const windowHeight = window.innerHeight;
		const delay = windowHeight * 0.1;
		const duration = windowHeight * 0.45;
		const percent = Math.min(1, Math.max(0, (-top - delay) / duration));
		this.heading.style.opacity = 1 - percent;
	}


}
